import { StyledCard } from '@/app/features/common/DetailStyles';
import { CommonParagraph } from '@/app/shared/common.StyledComponents';
import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const InvoiceNavigationCard = styled(StyledCard)`
    padding: ${rem(12)};
    border: ${rem(1)} solid ${({ theme }: any) => theme.colors.greyscale.gray15};
    border-radius: ${rem(4)};
    box-shadow: none;
    position: relative;
    height: 440px;
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
    line-height: ${({ theme }) => theme.typography.lineHeights.body.medium};
    color: black;
`;

export const NavigationHeader = styled.div`
    padding: 12px 20px 12px 16px;
`;

export const HeaderLeft = styled(CommonParagraph)`
    font-size: 32px;
    padding: 16px 32px 32px 32px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray40};
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const InvoiceAmountBox = styled.div`
    display: block;
    align-items: flex-start;
    box-sizing: border-box;
    flex-direction: row;
    padding: 12px 20px 12px 16px;
    width: fit-content;
    height: 80px;
    border: 1px solid #53565A;
    border-radius: 4px;
    margin-left:32px;
    font-size: 24px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray50};
`;

export const SmallInvoiceText = styled.div`
    font-size: 12px;
`;

export const SmallerHeaderRow = styled.div`
    box-sizing: border-box;
    display: -webkit-inline-box;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 16px 16px;
    margin-left:32px;
    width: 440px;
    background: #FFFFFF;
    border-bottom: 1px solid #E3E9F2;
    border-radius: 4px;
    font-size: 12px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray40};
`;

export const RightAlignedText = styled.div`
    margin-left:auto;
`;

export const InvoiceDetailsCard = styled(StyledCard)`
    padding: ${rem(12)};
    border: ${rem(1)} solid ${({ theme }: any) => theme.colors.greyscale.gray15};
    border-radius: ${rem(4)};
    box-shadow: none;
    position: relative;
    height: 250px;
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
    line-height: ${({ theme }) => theme.typography.lineHeights.body.medium};
    color: black;
`;

export const InvoiceDetailsHeader = styled(CommonParagraph)`
    font-size: 18px;
    padding: 16px 16px 0px 32px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray50};
`;

export const InvoiceDetailsColumnHeader = styled.div`
    padding: 8px 8px 0px 32px;
    width: 360px;
    background: #FFFFFF;
    font-size: 12px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray40};
`;

export const InvoiceDetailsColumnValues = styled.div`
    padding: 0px 0px 0px 32px;
    width: 360px;
    background: #FFFFFF;
    font-size: 16px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray40};
`;

export const InvoiceContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem(12)};
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
`;

export const InvoiceDetailsContentContainer = styled.div`
  flex: 1;
  min-width: 0;
  max-width: calc(100% - ${rem(312)});
  overflow: hidden;
`;

export const InvoiceNotesCard = styled(StyledCard)`
    padding: ${rem(12)};
    border: ${rem(1)} solid ${({ theme }: any) => theme.colors.greyscale.gray15};
    border-radius: ${rem(4)};
    box-shadow: none;
    position: relative;
    height: auto;
    max-height: calc(100vh - ${rem(200)});
    min-height: ${rem(550)};
    font-family: ${({ theme }) => theme.typography.fontFamilies.primary};
    line-height: ${({ theme }) => theme.typography.lineHeights.body.medium};
    color: black;
    overflow-y: auto;
    overflow-x: hidden;

    & [class*="StepperItem"] {
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
`;

export const InvoiceNotesHeader = styled(CommonParagraph)`
    font-size: 18px;
    padding: 16px 16px 16px 32px;
    font-family: "Gotham";
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: ${({ theme }) => theme.colors.greyscale.gray50};
`;

export const StepperWrapper = styled.div`
    padding-left: ${rem(32)};
`;

export const ActivityHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: ${rem(16)};
`;

export const InvoiceNavigationControls = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(16)};
`;

export const InvoiceNavigationInfo = styled.span`
    font-size: ${rem(14)};
    font-family: "Gotham";
    color: ${({ theme }) => theme.colors.greyscale.gray40};
    white-space: nowrap;
`;

export const InvoiceNavigationButtonsContainer = styled.div`
    display: flex;
    gap: ${rem(8)};
`;

export const InvoiceNavigationRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;